import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CheckOutService } from '../../../services/checkout.service';
import { CommonService } from '../../../services/common.service';
import { enterAnimation } from '../../../shared/animations.collections';
import { DickerSelectListItem, CheckoutViewModel, PaymentApiResponse, CheckoutStatusModel, PaymentViewModel, CheckoutSummaryViewModel } from '../../../models/check-out.model';
import { CustomerPaymentsOutput, CurrentUserModel, PaywayCustomerRequest } from '../../../models/account-ledger.model';
import { ShippingAddressViewModel } from '../../../models/shopping-cart.model';
import { AuthService } from '../../../services/auth.service';
// tslint:disable-next-line:import-blacklist
import { combineLatest, Subject } from 'rxjs';
import { ccform } from '../../../shared/JavaScript/paymentform';
import { MyAccountService } from '../../../services/myAccount.service';
import { NgProgressService } from '../../../services/ngProgress.service';
import { map, switchMap, take, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-payment',
  animations: [enterAnimation()],
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})
export class PaymentComponent implements OnInit, OnDestroy {

  title = 'Payment';
  setFullWindow = false;
  loadContent = false;
  loadPayment = false;
  isTenantRequired = true;
  poNumber: string;
  cartId: string;
  cartName: string;
  paymentMethod = '';
  paymentMethodValue = '';
  dropdownList: DickerSelectListItem[] = [];
  selectedWallet: DickerSelectListItem;
  customerPayments: CustomerPaymentsOutput[] = [];
  shippingAddressModel: ShippingAddressViewModel;
  checkoutViewModel: CheckoutViewModel;
  isValid: boolean;
  customer_number: string;
  name_on_card: string;
  card_scheme: string;
  cardInfo: string;
  checkoutStatus: CheckoutStatusModel;
  paymentView: PaymentViewModel;
  currentUserModel: CurrentUserModel;
  ngUnsubscribe: Subject<void> = new Subject<void>();
  paywayCustomer: PaywayCustomerRequest;
  apiKey: string;
  serial: string;

  backto: string;

  quoteId: string;
  public paymentSummary: CheckoutSummaryViewModel;
  public gst: string;
  public cartTotal: string;


  paymentMethods = [
    { value: '', viewValue: 'CHOOSE A PAYMENT METHOD' },
    { value: 'BPAY', viewValue: 'BPAY' },
    { value: 'MONEYTECH', viewValue: 'MONEY TECH' },
    { value: 'CREDITCARD', viewValue: 'Credit Card' },
    { value: 'DIGITALWALLET', viewValue: 'Digital Wallet' },
    { value: 'DIRECTDEPOSIT', viewValue: 'Direct Deposit' },
  ];

  paymentMethodsDD = [
    { value: 'DDAccount', viewValue: 'DICKERDATA CREDIT ACCOUNT' },
  ];

  paymentMethodsNZ = [
    { value: '', viewValue: 'CHOOSE A PAYMENT METHOD' },
    { value: 'CREDITCARD', viewValue: 'Credit Card' },
    { value: 'DIRECTDEPOSIT', viewValue: 'Direct Deposit' },
    { value: 'DIGITALWALLET', viewValue: 'Digital Wallet' }
  ];

  constructor(
    private router: Router
    , private activatedRoute: ActivatedRoute
    , private checkOutService: CheckOutService
    , private myAccountService: MyAccountService
    , private ngProgress: NgProgressService
    , private commonService: CommonService
    , private authService: AuthService) { }

  ngOnInit() {
    this.loadContent = false;
    this.activatedRoute.parent.url
      .subscribe(value => {
        this.cartId = value.length > 1 ? value[1].path : '';
        this.cartName = value.length > 1 ? value[2].path : '';
      },
        (error: any) => {
          console.error(error);
          this.loadContent = true;
        });

    this.authService.getLoginInfo()
      .subscribe((res: CurrentUserModel) => {
        this.currentUserModel = res;

        if (this.currentUserModel.isStaffAccount) {
          this.paymentMethods.push({ value: 'PAYLATER', viewValue: 'Pay Later' });
          this.paymentMethodsNZ.push({ value: 'PAYLATER', viewValue: 'Pay Later' });
        }
      },
        (error: any) => {
          console.error(error);
        });

    const payment$ = combineLatest(
      [
        this.myAccountService.GetCurrentPublishableKey(),
        this.checkOutService.GetPayment(this.cartId),
        this.checkOutService.GetDigitalWallet(),
        this.checkOutService.GetPaymentMethodList(),
        this.checkOutService.GetSummaryView(this.commonService.toNumber(this.cartId))
      ]
    );

    this.loadPayment = false;
    payment$.pipe(takeUntil(this.ngUnsubscribe)).pipe(take(1)).subscribe(([key, paymentViewModel, digitalwallet, paymentMethod, paymentSummary]) => {
      this.apiKey = key;

      this.paymentView = paymentViewModel;
      this.gst = paymentSummary?.payment?.cartTax?.replace(/[,$]/g, '');
      this.cartTotal = paymentSummary?.payment?.totalAmount?.replace(/[,$]/g, '');
      this.poNumber = this.paymentView.poReference;
      this.paymentSummary = paymentSummary
      if (this.paymentView.isDDCreditAccount) {
        this.paymentMethod = 'DDAccount';
        this.paymentMethodValue = 'DDAccount';
      } else if (this.paymentView.paymentMethod) {
        this.paymentMethod = this.paymentView.paymentMethod.replace(' ', '');
        this.paymentMethodValue = this.paymentView.paymentMethod.replace(' ', '');
        if (this.paymentMethod.toLowerCase() === 'creditcard') {
          this.showCCForm();
        }
      }

      this.dropdownList = digitalwallet;

      this.customerPayments = paymentMethod;

      this.loadPayment = true;

    })
    // this.myAccountService.GetCurrentPublishableKey().subscribe((key: string) => {
    //   this.apiKey = key;
    // },
    //   (error: any) => {
    //     console.error(error);
    //   });

    // this.checkOutService.GetPayment(this.cartId).subscribe((res: PaymentViewModel) => {
    //   this.loadContent = true;
    //   this.paymentView = res;
    //   this.poNumber = this.paymentView.poReference;
    //   if (this.paymentView.isDDCreditAccount) {
    //     this.paymentMethod = 'DDAccount';
    //     this.paymentMethodValue = 'DDAccount';
    //   } else if (this.paymentView.paymentMethod) {
    //     this.paymentMethod = this.paymentView.paymentMethod.replace(' ', '');
    //     this.paymentMethodValue = this.paymentView.paymentMethod.replace(' ', '');
    //     if (this.paymentMethod.toLowerCase() === 'creditcard'){
    //       this.showCCForm();
    //     }
    //   }
    // },
    //   (error: any) => {
    //     console.error(error);
    //     this.loadContent = true;
    //   });

    // this.checkOutService.GetDigitalWallet().subscribe((res: DickerSelectListItem[]) => {
    //   this.dropdownList = res;
    // },
    //   (error: any) => {
    //     console.error(error);
    //     this.loadContent = true;
    //   });

    // this.checkOutService.GetPaymentMethodList().subscribe((res: CustomerPaymentsOutput[]) => {
    //   this.customerPayments = res;
    // },
    //   (error: any) => {
    //     console.error(error);
    //   });

    this.checkOutService.currentCheckoutViewModel.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: CheckoutViewModel) => {
      this.checkoutViewModel = res;
    });

    // this.activatedRoute.parent.parent.paramMap.takeUntil(this.ngUnsubscribe).subscribe((params) => {
    //   this.serial = params.get('serial');
    // })
    this.activatedRoute.parent.parent.parent.paramMap.pipe(
      switchMap((params) => {
        return this.activatedRoute.parent.parent.paramMap.pipe(
          map((param) => {
            return {
              quoteId: params.get('sku'),
              serial: param.get('serial'),
            }
          })
        )
      })
    ).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res) => {
      this.quoteId = res.quoteId;
      this.serial = res.serial;
      if (this.quoteId) {
        this.backto = 'quote';
      } else if (this.serial) {
        this.backto = 'renewal';
      } else {
        this.backto = 'cart';
      }
    })
    // this.checkOutService.CartCheckout(toNumber(this.cartId)).subscribe((res: CheckoutViewModel) => {
    //   this.checkoutViewModel = res;
    // },
    //   (error: any) => {
    //     console.error(error);
    //     this.loadContent = true;
    //   });

    this.checkOutService.passModelWatch.subscribe((res: ShippingAddressViewModel) => {
      this.shippingAddressModel = res;

    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });

    this.loadContent = true;

    const isAutoPilotTenantRequired = localStorage.getItem('autoPilotTenant');
    if (isAutoPilotTenantRequired) {
      this.isTenantRequired = isAutoPilotTenantRequired === 'YES' ? true : false;
    }
  }

  showCCForm(): void {
    setTimeout(() => {
      ccform(this.apiKey);
    }, 100);
  }

  setPaywayCreditCardToken(): void {
    this.ngProgress.start();
    setTimeout(() => {
      this.customer_number = $('#msg').html();
      this.card_scheme = $('#card_type').html();

      if (this.customer_number == undefined || this.customer_number == 'undefined' || this.customer_number.length < 36) {
        this.commonService.implementToast('Please verify the credit card number', 'Info');
      }
      else {
        this.submitPayment();
      }
      this.ngProgress.done();
    }, 5000);

  }

  addNewPayment(): void {
    this.checkOutService.monitorRedirectToDW('PAYMENT');
    this.router.navigate(['digitalwallet'], { relativeTo: this.activatedRoute.parent });
  }

  selectDigitalCard(): void {
    this.cardInfo = this.selectedWallet.text + '/' + this.selectedWallet.value;
    if (this.paymentMethod.toLowerCase() === 'digitalwallet') {
      this.name_on_card = this.cardInfo.split('/')[2];
      this.customer_number = this.selectedWallet.value;
      this.card_scheme = this.cardInfo.split('/')[3];
    } else {
      this.name_on_card = this.cardInfo.split('/')[3];
      this.customer_number = this.cardInfo.split('/')[5];
      this.card_scheme = this.cardInfo.split('/')[4];
    }
    if (this.card_scheme && this.card_scheme.length > 0) { this.card_scheme = this.card_scheme.trim(); }
  }

  selectPaymentMethod(): void {
    this.paymentMethod = this.paymentMethodValue;
    if (this.paymentMethodValue === "CREDITCARD") {
      this.showCCForm();
    }
  }

  submitPayment(): void {
    this.isValid = true;
    if (!this.paymentMethod) {
      this.commonService.showError('#next-button', 'Please select a payment type to continue', 'right');
      this.isValid = false;
    } else if (this.paymentMethod.toLowerCase() === 'digitalwallet') {
      if (this.customerPayments == null || this.customerPayments.length < 1) {
        this.commonService.showError('#btnAddPaymentMethod', 'Please add payment method to continue', 'right');
        this.isValid = false;
        return;
      }
      if (!this.customer_number || !this.name_on_card) {
        this.commonService.showError('#selectcard', 'Please select or add payment method to continue', 'right');
        this.isValid = false;
      } else if (!this.customer_number || this.customer_number === 'SELECT') {
        this.commonService.showError('#selectcard', 'Please select a payment method to continue', 'right');
        this.isValid = false;
      }
    }

    if (!this.poNumber) {
      this.commonService.showError('.po-reference', 'Please enter order reference', 'right');
      this.isValid = false;
    }

    if (this.poNumber && this.poNumber.includes('|')) {
      this.commonService.showError('.po-reference', 'Invalid order reference, Please don\'t include pipe symbol', 'right');
      this.isValid = false;
    }

    if (this.isValid) {
      this.loadContent = false;
      if(this.paymentMethod.toLowerCase() === 'digitalwallet'){
        this.checkOutService.selectedDigitalWallet$.next(this.selectedWallet);
      }else{
        this.checkOutService.selectedDigitalWallet$.next(null);
      }
      this.checkOutService.ContinueToPayment(this.commonService.toNumber(this.cartId), this.paymentMethod, encodeURIComponent(this.poNumber), this.customer_number, this.card_scheme, this.name_on_card).subscribe((res: PaymentApiResponse) => {
        if (res.result && res.returnType === 'SUMMARY') {
          this.router.navigate(['summary-order'], { relativeTo: this.activatedRoute.parent });
        } else if (res.result && res.returnType === 'PAYWAY') {
          window.location.href = res.paywayURL;
          this.loadContent = true;
        }
      },
        (error: any) => {
          console.error(error);
          this.loadContent = true;
        });
    } else {
      this.loadContent = true;
    }
  }

  goPrevious(): void {

    // NZ site is not using donation page
    // if (this.currentUserModel.isAU) {
    //   this.router.navigate(['donation'], { relativeTo: this.activatedRoute.parent });
    // } else {
      if (this.isTenantRequired && this.checkoutViewModel && this.checkoutViewModel.tenantDetailsRequired === 'YES' && (this.checkoutViewModel.firstStep === 'TENANT' || this.checkoutViewModel.firstStep === 'NOENDUSER')) {
        // LoadSection("TENANT");
        this.router.navigate(['tenant'], { relativeTo: this.activatedRoute.parent });
      } else if (this.checkoutViewModel && this.checkoutViewModel.tenantDetailsRequired === 'YES' && this.checkoutViewModel.firstStep === 'ENDUSER') {
        this.router.navigate(['end-user'], { relativeTo: this.activatedRoute.parent });
      } else if ((this.shippingAddressModel && !this.shippingAddressModel.collectTheOrder && this.checkoutViewModel.firstStep === 'ENDUSER') || (this.shippingAddressModel && this.shippingAddressModel.collectTheOrder && this.checkoutViewModel.firstStep === 'ADDRESS') || (this.checkoutViewModel.allFreightFreeProducts === 'YES' && this.checkoutViewModel.containsDirectShippingProducts !== 'NO')) {
        // LoadSection("ENDUSER");
        this.router.navigate(['end-user'], { relativeTo: this.activatedRoute.parent });
      } else if ((this.shippingAddressModel && this.shippingAddressModel.collectTheOrder && this.checkoutViewModel.firstStep === 'NOENDUSER') || (this.shippingAddressModel && this.shippingAddressModel.collectTheOrder && this.checkoutViewModel.containsDirectShippingProducts === 'YES')) {
        // LoadSection("ADDRESS");
        this.router.navigate(['ship-address'], { relativeTo: this.activatedRoute.parent });
      } else {
        this.router.navigate(['freight-ship'], { relativeTo: this.activatedRoute.parent });
      }
    // }

  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }
  backtoCart() {
    this.checkOutService.monitorShowCartSummary('show');
    this.router.navigateByUrl(`/myCarts/cart/${this.cartId}/${this.cartName}`);
  }

  backtoRenewals() {
    this.router.navigate(['.'],{relativeTo:this.activatedRoute.parent.parent});
    //this.router.navigateByUrl(`manageRenewalsNew/renewalDetails/${this.serial}`);
  }

  backtoQuotes() {
    this.router.navigate(['.'], { relativeTo: this.activatedRoute.parent.parent });
    $('.combination-loader').animate(
      { scrollLeft: (250 + $('#price-list-detail').width()) }, 100)

  }

  getCartValue(): number {
    const totalPrice = this.paymentSummary?.payment?.totalAmount?.replace(/[,$]/g,'');
    const tax = this.paymentSummary?.payment?.cartTax?.replace(/[,$]/g, '');

    return Number(totalPrice) - Number(tax);
  }

  close() {

    // this.checkoutStatus = {
    //   currentStep: '',
    //   firstStep: '',
    //   hasChosenCheckout: false,
    //   collectOrder: false,
    //   tenantDetailsRequired: ''
    // };
    // this.checkOutService.emitChange(this.checkoutStatus);
    // this.router.navigateByUrl(`/myCarts/cart/${this.cartId}/${this.cartName}`);
    this.router.navigate(['../'], { relativeTo: this.activatedRoute });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
